"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloTypes = void 0;
exports.siloTypes = {
    SET_LOADING: 'SILO TYPES SET LOADING',
    SET_ERROR: 'SILO TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'SILO TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'SILO TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'SILO TYPES ON MUTATION',
    ON_SORT_CHANGE: 'SILO TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE: 'SILO TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'SILO TYPES ON SAVE DATAITEM',
    ON_DELETE_DATAITEM: 'SILO TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'SILO TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'SILO TYPES SET SUCCESS MODAL',
};
